<template>
    <div  v-if="isLargeScreen">
  
      <div>
        <Breadcrumbs main="Withdraw Funds" title="Withdraw Funds" />
  
        <div class="container-fluid">
            <div class="row widget-grid m-lg-5 d-flex align-items-stretch">
              <div class="col-md-4 d-flex flex-column">
                  <NowButton />
                  <Account />
              </div>

              <div class="col-md-8 d-flex">
                  <History class="flex-fill" />
              </div>
            </div>
        </div>
      </div>
    </div>
    <div v-else>
      <MobileHelp />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import NowButton from './nowButtonCard.vue';
  import Account from './account.vue';
  import History from './history.vue';
  import MobileHelp from './mobile/index.vue';
  
  const isLargeScreen = ref(true);
    
    // 檢查螢幕大小
    function checkScreenSize() {
      isLargeScreen.value = window.innerWidth >= 992;
    }
    
    onMounted(() => {
      checkScreenSize();
      window.addEventListener('resize', checkScreenSize);
    });
    
    onUnmounted(() => {
      window.removeEventListener('resize', checkScreenSize);
    });
  </script>